import { render, staticRenderFns } from "./PlanejamentoContrato.vue?vue&type=template&id=5357d0c2"
import script from "./PlanejamentoContrato.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports